import type { ServiceTrustCardProps } from "@/components/screen/global-components/services/ServiceTrustCard";

const servicesTrustContentUrgent = {
  title: "Rest assured with Languex for same day translation services",
  description: null,
} as const;

const servicesTrustCardsUrgent: ServiceTrustCardProps[] = [
  {
    title: "24/7 support and availability",
    description:
      "Start your urgent translation immediately with a wide global network of translators available across time zones. Access 24/7 support with industry-leading response times, and get real-time updates in our easy-to-use platform.",
    href: "/quality-guarantee",
    linkLabel: "Discover our quality guarantee",
  },
  {
    title: "Speed without sacrifice",
    description:
      "A rushed translation still requires accuracy. We use a proprietary process with each translation reviewed by a second linguist specializing in your industry, with built-in quality assurance to validate accuracy and offer unlimited free revisions.",
    href: "https://www.trustpilot.com/review/www.languex.co",
    linkLabel: "Explore our reviews",
    target: "_blank",
    rel: "noopener noreferrer",
  },
  {
    title: "Trusted by professionals",
    description:
      "Businesses trust Languex for urgent translations because of our commitment to precision. Unlike AI tools or generic translation agencies, we offer specialized human expertise to ensure context-aware accuracy—even on the fastest turnarounds.",
    href: "/documents/compliance",
    linkLabel: "Review our compliance",
  },
];

export const servicesTrustMap = {
    urgent: {
    content: servicesTrustContentUrgent,
    cards: servicesTrustCardsUrgent,
  },
};
